module.exports = __webpack_public_path__ + "static/1293545906.80432344.jpg";